































































































import { Component, Vue } from 'vue-property-decorator';
import { CatalogItemFullDTO, PictureDTO } from '@/api';
import IconTimes from '@/assets/icons/times.svg';
import services from '@/services';
import { getAssetUrl } from '@/utils';

@Component({
  name: 'thing-info',
  components: { IconTimes },
})
export default class ShoppingThingInfo extends Vue {
  opened = false;

  thing: CatalogItemFullDTO | null = null;

  get price() {
    return this.thing && this.thing.prices && this.thing.prices[0];
  }

  get pictures(): PictureDTO[] {
    if (this.thing && this.thing.pictures) {
      if (this.thing.pictures.some(item => item.size === 'SMALL')) {
        return this.thing.pictures.filter(item => item.size === 'SMALL');
      }
      if (this.thing.pictures.some(item => item.size === 'MEDIUM')) {
        return this.thing.pictures.filter(item => item.size === 'MEDIUM');
      }
      return this.thing.pictures.filter(item => item.size === 'BIG');
    }
    return [];
  }

  async open(id: number) {
    if ((this.thing && this.thing.id) !== id) {
      this.fetchItem(id);
    }
    this.opened = true;
  }

  close() {
    this.opened = false;
  }

  imgUrl(path: string) {
    return getAssetUrl(path);
  }

  async fetchItem(id: number) {
    try {
      const { data } = await services
        .catalogService()
        .catalogEndpointGetItem(id);
      this.thing = data;
    } catch (error) {
      // console.error(error);
      this.$notify({ title: 'Ошибка!', message: error, type: 'error' });
    }
  }
}
